export default __webpack_public_path__ + "static/media/learn-more-card-3.e3074087.svg";